import {
    UPDATE_USER,
    UPDATE_USER_FAILURE,
    UPDATE_USER_SUCCESS,

    UPDATE_USER_ACTIVITY_FAILURE,
    UPDATE_USER_ACTIVITY_SUCCESS,

    UPDATE_USER_CONFIRMATION_FAILURE,
    UPDATE_USER_CONFIRMATION_SUCCESS,
} from 'store/actions/types';

export const updateUser = (payload) => {
    return {
        type: UPDATE_USER,
        payload: payload,
    };
};

export const updateUserFailure = (error) => {
    return {
        type: UPDATE_USER_FAILURE,
        error: error,
    };
};

export const updateUserSuccess = (id, response) => {
    return {
        type: UPDATE_USER_SUCCESS,
        id: id,
        response: response,
    };
};

export const updateUserActivityFailure = (error) => {
    return {
        type: UPDATE_USER_ACTIVITY_FAILURE,
        error: error,
    };
};

export const updateUserActivitySuccess = (response) => {
    return {
        type: UPDATE_USER_ACTIVITY_SUCCESS,
        response: response,
    };
};

export const updateUserConfirmationFailure = (error) => {
    return {
        type: UPDATE_USER_CONFIRMATION_FAILURE,
        error: error,
    };
};

export const updateUserConfirmationSuccess = (response) => {
    return {
        type: UPDATE_USER_CONFIRMATION_SUCCESS,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/users/updateUsers.js